import React, { useState } from 'react';
import styled from 'styled-components';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import {
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    Input,
    Button
} from '../styles/Modal.styles';

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  color: #B6C2CF;
  font-weight: 500;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
`;

const Label = styled.label`
  font-size: 14px;
  color: #B6C2CF;
  font-weight: 500;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
`;

const CancelButton = styled(Button)`
  background: transparent;
  border: none;
  color: #B6C2CF;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const AddButton = styled(Button)`
  background: #579DFF;
  border: none;
  color: white;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;

  &:hover:not(:disabled) {
    background: #398BFF;
  }

  &:disabled {
    background: #579DFF;
    opacity: 0.5;
  }
`;

const AddPlanModal = ({ isOpen, onClose }) => {
    const { user } = useAuth();
    const [planText, setPlanText] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!planText.trim()) return;

        setIsSubmitting(true);

        try {
            const userTodosRef = doc(db, 'userTodos', user.uid);
            const newItem = {
                id: `todo-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                text: planText.trim(),
                completed: false,
                createdAt: new Date().toISOString()
            };

            // Get current items and append the new one
            const userTodosSnap = await getDoc(userTodosRef);
            let currentItems = [];
            if (userTodosSnap.exists()) {
                currentItems = userTodosSnap.data().items || [];
            }
            const updatedItems = [...currentItems, newItem];

            // Update userTodos with the new item
            await updateDoc(userTodosRef, {
                items: updatedItems,
                updatedAt: new Date().toISOString()
            });

            setPlanText('');
            onClose();
        } catch (error) {
            console.error('Error adding plan item:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <ModalOverlay onClick={onClose} style={{ background: 'rgba(0, 0, 0, 0.7)', paddingTop: '48px', alignItems: 'start' }}>
            <ModalContent onClick={(e) => e.stopPropagation()} style={{ background: '#282E33', borderRadius: '8px', maxWidth: '90%', width: '600px', padding: 0, boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)' }}>
                <ModalHeader style={{ background: '#22272B', borderRadius: '8px 8px 0 0', borderBottom: '1px solid #3B444C', padding: '20px' }}>
                    <ModalTitle>Add New Plan</ModalTitle>
                    <Button style={{ background: 'none', border: 'none', fontSize: '20px', color: '#8C9BAB', cursor: 'pointer', padding: '4px 8px', borderRadius: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>×</Button>
                </ModalHeader>
                <ModalBody>
                    <form onSubmit={handleSubmit} style={{ paddingLeft: '20px', paddingRight: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <FormGroup>
                            <Label htmlFor="planText">Planned Item</Label>
                            <Input
                                type="text"
                                id="planText"
                                value={planText}
                                onChange={(e) => setPlanText(e.target.value)}
                                placeholder="Add your planned idea..."
                                required
                                style={{ background: '#22272B', border: '2px solid #3B444C', color: '#B6C2CF', fontSize: '14px', padding: '8px 12px' }}
                            />
                        </FormGroup>
                        <ButtonGroup>
                            <CancelButton type="button" onClick={onClose}>
                                Cancel
                            </CancelButton>
                            <AddButton type="submit" disabled={isSubmitting}>
                                {isSubmitting ? 'Adding...' : 'Add Plan'}
                            </AddButton>
                        </ButtonGroup>
                    </form>
                </ModalBody>
            </ModalContent>
        </ModalOverlay>
    );
};

export default AddPlanModal;
